import { render, staticRenderFns } from "./TabellaFatture.vue?vue&type=template&id=197ce307&"
import script from "./TabellaFatture.vue?vue&type=script&lang=js&"
export * from "./TabellaFatture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports